import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { ProductSearchResultSchema } from "../search-products";

export const uploadAdjustmentItemsCsv = {
  name: "uploadAdjustmentItemsCsv" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({
    parseErrors: z.array(z.string()),
    rows: z.array(
      z.object({
        rowNumber: z.number().int().positive(),
        sku: z.string(),
        quantity: z.number().int().positive().optional(),
        message: z.string().optional(),
        product: ProductSearchResultSchema.optional(),
      }),
    ),
  }),
};
